import React, { useEffect, useMemo } from "react";
import { useMountEffect } from "primereact/hooks";
import { connect } from "react-redux";
import { useIntl } from "react-intl";
import { Message } from "primereact/message";
import Section from "../../common/section";
import { NotificationConstants } from "../../../constants";
import {
  notificationsRequest,
  updateNotificationReadRequest,
} from "../../../store/slices/selfSlice";
import dayjs from "dayjs";
import { Tooltip } from "primereact/tooltip";

const NotificationAlerts = ({
  notificationsRequest,
  notifications,
  error,
  action,
  requesting,
  updateNotificationReadRequest,
}) => {
  const intl = useIntl();

  useMountEffect(() => {
    notificationsRequest();
  });

  useEffect(() => {
    if (!error && !requesting && action === "update-notification-read") {
      notificationsRequest();
    }
  }, [error, action, requesting]);

  const messages = useMemo(() => {
    return (
      (notifications.length > 0 &&
        notifications.map((notification, index) => {
          const notificationType =
            NotificationConstants.NOTIFICATION_TYPES.find(
              (item) => item.value === notification.type
            );
          return {
            key: `notification-${index}`,
            severity: notificationType.severity,
            detail: intl.formatMessage({ id: notificationType.label }),
            summary: notification.subjectName,
            closable: false,
            sticky: true,
            createdAt: notification.createdAt,
            id: notification.id,
          };
        })) ||
      []
    );
  }, [notifications, intl]);

  const markAsRead = (message) => {
    updateNotificationReadRequest({ id: message.id });
  };

  return (
    <Section
      title="notification_alerts"
      className="edelxms-widget notitications"
      headerAction={
        (notifications.length && (
          <div onClick={() => updateNotificationReadRequest({ id: "all" })}>
            <Tooltip target=".pi.pi-trash" />
            <i
              className="pi pi-trash"
              style={{ fontSize: "1.5rem", cursor: "pointer" }}
              data-pr-tooltip={intl.formatMessage({ id: "mark_all_as_read" })}
              data-pr-position="left"
            />
          </div>
        )) ||
        null
      }
    >
      {(messages.length &&
        messages.map((message) => {
          return (
            <Message
              key={message.key}
              severity={message.severity}
              className={message.className}
              style={message.style}
              text={
                <div style={{ width: "100%" }}>
                  <div className="flex gap-2 align-items-center justify-content-between">
                    <div>
                      <div>
                        {message.summary} {message.detail}
                      </div>
                      <div style={{ marginTop: 4, fontSize: "12px" }}>
                        {dayjs(message.createdAt).format("DD MMM YYYY")}
                      </div>
                    </div>
                    <div onClick={() => markAsRead(message)}>
                      <i
                        className="pi pi-times"
                        style={{ cursor: "pointer" }}
                      />
                    </div>
                  </div>
                </div>
              }
            ></Message>
          );
        })) || <span>{intl.formatMessage({ id: "no_notifications" })}</span>}
    </Section>
  );
};

const mapStateToProps = (state) => ({
  notifications: state.self.notifications,
  action: state.self.action,
  requesting: state.self.requesting,
  error: state.self.error,
});

const mapDispatchToProps = (dispatch) => ({
  notificationsRequest: () => dispatch(notificationsRequest()),
  updateNotificationReadRequest: (message) =>
    dispatch(updateNotificationReadRequest(message)),
});

export default connect(mapStateToProps, mapDispatchToProps)(NotificationAlerts);
